import {useMapContext} from '@/components/MindMap/index.mjs'
import openWindow from '@/script/openWindow.mjs'

export default () => {
    const map = useMapContext()
    const {mapTypeCode, prjId, sVer} = map.data

    if ('SA_MAP' !== mapTypeCode) {
        return null
    }

    const onClick = () => openWindow('/DoAnalysisHandle', {prjId, sVer})

    return {
        label: '数据对象逆向分析处置',
        onClick,
    }
}
